import { Input } from "antd";
import { SearchOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useState } from "react";

export const SearchBar = ({ setSearch }) => {
  const [value, setValue] = useState();

  //  Update the search value
  const handleChange = (event) => {
    var value = event.target.value;
    setValue(value);
    if (setSearch) setSearch(value);
  };

  return (
    <Input
      style={{ height: 40, borderRadius: 8 }}
      prefix={<SearchOutlined />}
      value={value}
      suffix={
        value ? (
          <CloseCircleOutlined
            className="lightColor"
            onClick={() => setValue(null)}
          />
        ) : null
      }
      placeholder="Search products"
      onChange={handleChange}
      //   size="large"
    />
  );
};
